import { Box, Chip, TextField, Button, Typography, makeStyles, useTheme } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { SelectAll as SelectAllIcon, Clear as ClearIcon } from "@material-ui/icons";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  // ✅ CORREGIDO: Chip dinámico según tema
  chip: {
    backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#bfbfbf',
    color: theme.mode === 'dark' ? theme.palette.text.primary : 'white',
    border: `1px solid ${theme.mode === 'dark' ? '#6B7280' : '#bfbfbf'}`,
    textShadow: theme.mode === 'dark' ? 'none' : '1px 1px 1px #000',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#6B7280' : '#a8a8a8',
    },
  },
  // ✅ CORREGIDO: Button dinámico según tema
  button: {
    color: theme.palette.text.primary,
    borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-disabled': {
      color: theme.mode === 'dark' ? '#6B7280' : '#bdbdbd',
      borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
    },
  },
}));

export function UsersFilter({ onFiltered, initialUsers }) {
  const classes = useStyles();
  const theme = useTheme();
  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadUsers();
    }
    fetchData();
  }, []);

  useEffect(() => {
    setSelecteds([]);
    if (
      Array.isArray(initialUsers) &&
      Array.isArray(users) &&
      users.length > 0
    ) {
      onChange(initialUsers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialUsers, users]);

  const loadUsers = async () => {
    try {
      const { data } = await api.get(`/users/list`);
      const userList = data.map((u) => ({ id: u.id, name: u.name }));
      setUsers(userList);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  // ✅ FUNCIONES PARA SELECCIÓN MASIVA
  const handleSelectAll = () => {
    onChange(users);
  };

  const handleClearAll = () => {
    onChange([]);
  };

  const isAllSelected = selecteds.length === users.length && users.length > 0;
  const isSomeSelected = selecteds.length > 0;

  return (
    <Box style={{ padding: "0px 10px 10px" }}>
      {/* ✅ BOTONES DE SELECCIÓN MASIVA */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
          {selecteds.length} de {users.length} usuarios seleccionados
        </Typography>
        <Box>
          <Button
            size="small"
            variant="outlined"
            startIcon={<SelectAllIcon style={{ color: theme.palette.text.primary }} />}
            onClick={handleSelectAll}
            disabled={isAllSelected}
            className={classes.button}
            style={{ marginRight: 8 }}
          >
            Seleccionar Todos
          </Button>
          <Button
            size="small"
            variant="outlined"
            startIcon={<ClearIcon style={{ color: theme.palette.text.primary }} />}
            onClick={handleClearAll}
            disabled={!isSomeSelected}
            className={classes.button}
          >
            Limpiar
          </Button>
        </Box>
      </Box>

      <Autocomplete
        multiple
        size="small"
        options={users}
        value={selecteds}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => {
          return (
            option?.id === value?.id ||
            option?.name.toLowerCase() === value?.name.toLowerCase()
          );
        }}
        renderTags={(value, getUserProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              className={classes.chip}
              label={option.name}
              {...getUserProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Buscar usuarios o usar botones de selección masiva"
            helperText="Usa los botones de arriba para seleccionar todos o limpiar la selección"
            className={classes.textField}
          />
        )}
        PaperComponent={({ children, ...other }) => (
          <div {...other} style={{ 
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
            borderRadius: 8,
            marginTop: 4,
            boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.15)',
          }}>
            {children}
          </div>
        )}
        ListboxProps={{
          style: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          },
        }}
      />
    </Box>
  );
}
